import { colors } from '@fronton/tokens';
import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { passthrough, useStyleProps } from '../utils';
import { isDarkMode } from '../utils/is-dark-mode';
import styles from './styles.module.css';
import { tokens } from './theme-tokens';
export function useThemeProvider(props) {
  const {
    theme = 'light',
    override,
    children
  } = props;
  const rootRef = useRef(null);
  const predefinedTheme = predefinedThemes[theme];
  const themeIsClassName = typeof theme === 'string' && !predefinedTheme;
  const partialThemeIsClassName = typeof override === 'string';
  const {
    style
  } = useStyleProps({ ...theme,
    ...(!override || partialThemeIsClassName ? {} : override)
  }, themeHandlers);
  const className = clsx(styles.themeProvider, styles.tokens, predefinedTheme, themeIsClassName && theme, partialThemeIsClassName && override);
  useEffect(() => {
    if (rootRef.current && isDarkMode()) {
      Object.entries(tokens).forEach(([key, value]) => {
        var _rootRef$current;

        (_rootRef$current = rootRef.current) == null ? void 0 : _rootRef$current.style.setProperty(`--${key}`, value);
      });
    }
  }, [override, partialThemeIsClassName, predefinedTheme, theme, themeIsClassName]);
  return {
    style,
    className,
    ref: rootRef,
    children
  };
}
const predefinedThemes = {
  light: styles.lightTheme
};
let themeHandlers = {};

for (const color of Object.keys(colors)) {
  themeHandlers[color] = [`--${color}`, passthrough];
}